import type { Client, GlobalAndSpaceRootLinks } from "../client";
import type { EnabledFeatureToggles } from "../resources/enabledFeatureToggles";
import type { ResourceWithId } from "../resources/resource";

export class ConfigurationRepository<TResource extends ResourceWithId> {
    protected client: Client;
    private configurationLinkName: GlobalAndSpaceRootLinks;

    constructor(configurationLinkName: GlobalAndSpaceRootLinks, client: Client) {
        this.configurationLinkName = configurationLinkName;
        this.client = client;
    }
    get(): Promise<TResource> {
        return this.client.get<TResource>(this.client.getLink(this.configurationLinkName));
    }

    modify(resource: TResource): Promise<TResource> {
        return this.client.update<TResource>(resource.Links["Self"], resource);
    }

    clearCache(): Promise<void> {
        const clearCacheLink = this.client.getLink("VersionControlClearCache");
        return this.client.post(clearCacheLink, {});
    }

    enabledFeatureToggles(): Promise<EnabledFeatureToggles> {
        const enabledFeatureToggleLink = this.client.getLink("EnabledFeatureToggles");
        return this.client.get(enabledFeatureToggleLink, {});
    }
}
